import {gql} from '@apollo/client';
import {REVIEW_DETAILS_FRAGMENT} from '../../graphql/fragments';

export const SUBMIT_REVIEW = gql`
  mutation SubmitReview($reviewId: UUID!) {
    submitReview(reviewId: $reviewId) {
      ok
      review {
        ...ReviewDetailsFragment
      }
    }
  }
  ${REVIEW_DETAILS_FRAGMENT}
`;
